export const translations = Object.freeze({
  en: Object.freeze({
    pageTitle: 'Image Effects — Versioned effect archive',
    skipToContent: 'Skip to effects',
    brand: 'IMAGE / EFFECTS',
    edition: 'PUBLIC ARCHIVE · 01',
    heroEyebrow: 'Versioned visual recipes',
    heroTitle: 'A small library for deliberate transformations.',
    heroBody:
      'Install the collection, inspect its source, then invoke a pinned effect on your own image or idea. A growing semantic library; no subject-bound buckets.',
    archiveLabel: 'Archive status',
    effectCount: '{count} effect',
    effectCountPlural: '{count} effects',
    schemaLabel: 'Schema {version}',
    updatedLabel: 'Built {date}',
    installLabel: 'Install the skill',
    copyInstall: 'Copy install command',
    copiedInstall: 'Install command copied.',
    languageLabel: 'Switch language',
    languageAction: '中文',
    themeLabel: 'Change color theme',
    themeSystem: 'System',
    themeDark: 'Dark',
    themeLight: 'Light',
    themeValue: 'Theme · {theme}',
    motionLabel: 'Toggle interface motion',
    motionOn: 'On',
    motionOff: 'Off',
    motionValue: 'Motion · {motion}',
    searchLabel: 'Search the archive',
    searchPlaceholder: 'Search title, summary, or version…',
    categoryLabel: 'Filter by category',
    categoryAll: 'All categories',
    categories: Object.freeze({
      'academic-figures': 'Academic Figures',
      'assets-and-props': 'Assets & Props',
      'avatars-and-profile': 'Avatars & Profile',
      'branding-and-packaging': 'Branding & Packaging',
      'editing-workflows': 'Editing Workflows',
      portrait: 'Portrait',
      editorial: 'Editorial',
      'grids-and-collages': 'Grids & Collages',
      infographics: 'Infographics',
      maps: 'Maps',
      'portraits-and-characters': 'Portraits & Characters',
      'poster-and-campaigns': 'Posters & Campaigns',
      'product-visuals': 'Product Visuals',
      'scenes-and-illustrations': 'Scenes & Illustrations',
      'storyboards-and-sequences': 'Storyboards & Sequences',
      'slides-and-visual-docs': 'Slides & Visual Docs',
      'technical-diagrams': 'Technical Diagrams',
      'typography-and-text-layout': 'Typography & Text Layout',
      'ui-mockups': 'UI Mockups',
      zine: 'Zine',
    }),
    resultsLabel: '{visible} shown / {total} total',
    loading: 'Loading the verified effect library…',
    loadErrorCode: 'LOAD / ERROR',
    loadErrorTitle: 'The archive could not be loaded.',
    retry: 'Retry loading',
    emptyCode: 'FILTER / EMPTY',
    emptyTitle: 'No effects match these filters.',
    emptyBody: 'The library is available; adjust the search or category to see it again.',
    resetFilters: 'Reset filters',
    selectEffect: 'Select {title}',
    selected: 'Selected',
    notSelected: 'Select effect',
    version: 'Version',
    category: 'Category',
    input: 'Input',
    output: 'Output',
    imageInput: '{min} image · {formats}',
    imageInputPlural: '{min}–{max} images · {formats}',
    textOrImageInput: 'Text or up to {max} image · {formats}',
    outputCount: '{count} image',
    outputCountPlural: '{count} images',
    cardDetails: 'Details & source',
    recipeLabel: 'Invocation',
    source: 'Open source recipe',
    license: '{spdx} license',
    provenanceLabel: 'Provenance',
    repository: 'Repository',
    revision: 'Revision',
    previewCredit: 'Preview',
    previewCreditValue: '{author} · {license}',
    selectionNone: 'No effects selected',
    selectionCount: '{count} selected',
    selectionNames: 'Selected: {names}',
    clearSelection: 'Clear selection',
    copySelected: 'Copy selected invocation',
    copiedSelected: 'Versioned invocation copied.',
    copyFailed: 'Copy failed. Select the text and copy it manually.',
    footer: 'A transparent catalog built from versioned, attributed source.',
    imageAlt: 'Preview of {title}',
  }),
  zh: Object.freeze({
    pageTitle: '图像效果库 — 版本化效果档案',
    skipToContent: '跳到效果列表',
    brand: 'IMAGE / EFFECTS',
    edition: '公开档案 · 01',
    heroEyebrow: '版本化视觉配方',
    heroTitle: '一座小而克制的图像效果档案。',
    heroBody: '安装效果集，检查公开来源，再把锁定版本的效果用于你的图片或想法。按视觉语义持续扩展，不再按案例主体分桶。',
    archiveLabel: '档案状态',
    effectCount: '{count} 个效果',
    effectCountPlural: '{count} 个效果',
    schemaLabel: 'Schema {version}',
    updatedLabel: '构建于 {date}',
    installLabel: '安装 Skill',
    copyInstall: '复制安装命令',
    copiedInstall: '已复制安装命令。',
    languageLabel: '切换语言',
    languageAction: 'EN',
    themeLabel: '切换颜色主题',
    themeSystem: '跟随系统',
    themeDark: '深色',
    themeLight: '浅色',
    themeValue: '主题 · {theme}',
    motionLabel: '切换界面动效',
    motionOn: '开启',
    motionOff: '关闭',
    motionValue: '动效 · {motion}',
    searchLabel: '搜索档案',
    searchPlaceholder: '搜索标题、摘要或版本…',
    categoryLabel: '按分类筛选',
    categoryAll: '全部分类',
    categories: Object.freeze({
      'academic-figures': '学术配图',
      'assets-and-props': '素材资产',
      'avatars-and-profile': '头像人设',
      'branding-and-packaging': '品牌包装',
      'editing-workflows': '图像编辑',
      portrait: '人物',
      editorial: '编辑设计',
      'grids-and-collages': '网格拼贴',
      infographics: '信息图',
      maps: '地图',
      'portraits-and-characters': '人物视觉',
      'poster-and-campaigns': '海报营销',
      'product-visuals': '产品视觉',
      'scenes-and-illustrations': '氛围插画',
      'storyboards-and-sequences': '叙事序列',
      'slides-and-visual-docs': '视觉文档',
      'technical-diagrams': '技术图示',
      'typography-and-text-layout': '字体版式',
      'ui-mockups': '界面样机',
      zine: '纸本杂志',
    }),
    resultsLabel: '显示 {visible} / 共 {total}',
    loading: '正在加载已验证的效果库…',
    loadErrorCode: '加载 / 失败',
    loadErrorTitle: '效果档案加载失败。',
    retry: '重新加载',
    emptyCode: '筛选 / 空结果',
    emptyTitle: '没有符合当前筛选条件的效果。',
    emptyBody: '效果库本身不为空；修改搜索或分类即可重新看到内容。',
    resetFilters: '重置筛选',
    selectEffect: '选择「{title}」',
    selected: '已选择',
    notSelected: '选择效果',
    version: '版本',
    category: '分类',
    input: '输入',
    output: '输出',
    imageInput: '{min} 张图片 · {formats}',
    imageInputPlural: '{min}–{max} 张图片 · {formats}',
    textOrImageInput: '文字或最多 {max} 张图片 · {formats}',
    outputCount: '{count} 张图片',
    outputCountPlural: '{count} 张图片',
    cardDetails: '详情与来源',
    recipeLabel: '调用方式',
    source: '查看效果源码',
    license: '{spdx} 许可',
    provenanceLabel: '来源信息',
    repository: '仓库',
    revision: '修订版本',
    previewCredit: '预览图',
    previewCreditValue: '{author} · {license}',
    selectionNone: '尚未选择效果',
    selectionCount: '已选择 {count} 个',
    selectionNames: '已选择：{names}',
    clearSelection: '清空选择',
    copySelected: '复制所选调用语句',
    copiedSelected: '已复制含版本号的调用语句。',
    copyFailed: '复制失败，请手动选择并复制文本。',
    footer: '由版本化、可追溯的公开来源构成。',
    imageAlt: '「{title}」效果预览',
  }),
});
